<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="12" md="12" lg="12" class="mt-2">
        <div class="text-subtitle-1">¿Requiere amplificadores?</div>
      </v-col>
      <v-col
        cols="6"
        sm="12"
        md="6"
        lg="6"
        v-for="(bodypart, index) in model.audiometryTest"
        :key="index"
      >
        <span>
          <strong>{{ bodypart.bodyParts.name }}</strong>
        </span>
        <validation-provider
          v-slot="{}"
          name="requiere amplificadores"
          rules="required"
        >
          <v-radio-group
            v-model="bodypart.requiredAmplifier"
            :disabled="isViewDetailsForm"
          >
            <v-col cols="2">
              <v-radio label="Sí" :value="true"> </v-radio>
            </v-col>
            <v-col cols="2">
              <v-radio label="No" :value="false"> </v-radio>
            </v-col>
          </v-radio-group>
        </validation-provider>
        <div v-if="bodypart.requiredAmplifier == true">
          <validation-provider
            v-slot="{ errors, touched, invalid }"
            name="Nivel de pérdida auditiva"
            rules="required"
          >
            <v-autocomplete
              label="Nivel de pérdida auditiva"
              v-model="bodypart.levelHearingLoss"
              :error-messages="errors"
              required
              :clear-icon="$cnst.CLEAR_ICON"
              clearable
              :items="listRangeOfHearingLoss"
              item-text="name"
              return-object
              :disabled="isViewDetailsForm"
              :counter="20"
              ><v-icon slot="append" :color="touched && invalid ? 'error' : ''">
                {{ touched && invalid ? "mdi-alert" : "" }}
              </v-icon>
            </v-autocomplete>
          </validation-provider>
        </div>
      </v-col>
      <v-col>
        <h4 class="red--text">
          NOTA: El equipo médico (amplificadores) cubre necesidades de grado
          leve a moderado” (36 a 60 DB).
        </h4>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { AudiometryComponentsService } from "@/app/services";
export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
  },
  components: {
    ValidationProvider,
  },
  data() {
    return {
      listRangeOfHearingLoss: [],
    };
  },
  mounted() {
    this.listAllRangeOfHearingLoss();
  },
  methods: {
    listAllRangeOfHearingLoss() {
      AudiometryComponentsService.listRangeHearingLoss().then((res) => {
        this.listRangeOfHearingLoss = res.data;
      });
    },
  },
};
</script>

<style></style>
